import { ArrowRight, type LucideIcon } from "lucide-react";
import { Box, Card, CardActionArea, Grid, useTheme } from "@mui/material";
import { Typography } from "@powerdiary/components-library/lib";
import styles from "./HomeActionitem.module.css";

interface IProps {
    onClick: () => void;
    icon: LucideIcon;
    title: string;
    description: string;
}

export default function HomeActionItem({ onClick, icon: Icon, title, description }: IProps) {
    const theme = useTheme();

    return (
        <Grid
            data-test-id="home-action-item"
            size={{
                xxs: 12,
                xs: 6,
                md: 4,
                lg: 3,
            }}
        >
            <Card onClick={onClick} variant="elevation" className={styles.card}>
                <CardActionArea className={styles.cardActionArea}>
                    <Box>
                        <Icon color={theme.palette.primary.main} size={24} strokeWidth={2} aria-hidden />
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            flexGrow: 1,
                        }}
                    >
                        <Typography variant="paragraphLargeBold">{title}</Typography>
                        <Typography variant="paragraphSmallRegular" mt={1}>
                            {description}
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                        <ArrowRight color={theme.palette.primary.main} size={24} strokeWidth={2} aria-hidden />
                    </Box>
                </CardActionArea>
            </Card>
        </Grid>
    );
}
